import { render } from "./CardBody.vue?vue&type=template&id=79995e8e&ts=true"
import script from "./CardBody.vue?vue&type=script&lang=ts"
export * from "./CardBody.vue?vue&type=script&lang=ts"

import "./CardBody.vue?vue&type=style&index=0&id=79995e8e&lang=scss"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__